import './radio-group.scss';

import InputWrapper from '../input-wrapper/input-wrapper';

const RadioGroup = (props) => {
    const {
        error,
        displayError,
        message,
        helpertext,
        label,
        tooltip,
        options,
        value,
        defaultValue,
        ...inputProps
    } = props

    return (
        <fieldset className={`input-radio-group`} >
          <legend className="label">{props.label}</legend>
          <span id={`${props.id || props.name}_help`} className="helpertext">
            {props.helpertext}
        </span>
        <div className={`${props.className || ''}`} style={props.style} >
                {props.options && props.options.map((option) => 
                    <label htmlFor={`${props.id || props.name}_${option.value}`} key={`${props.id || props.name}_${option.value}`} className={`input input-radio ${error && displayError ? 'error' :''}`}>
                        <span className="group">
                            <input 
                                id={`${props.id || props.name}_${option.value}`}
                                name={props.name} 
                                type="radio"
                                {...inputProps}
                                checked={value === option.value}
                                value={option.value}
                
                            />
                            <span className="svg-radio">
                                <svg className="svg" width="24px" height="24px" viewBox="0 0 24 24">
                                    <circle className="fill" cx="12" cy="12" r="11"></circle>
                                    <circle className="stroke" cx="12" cy="12" r="11"></circle>
                                </svg>
                            </span>
                            <span className="label-inline">
                                {option.label}
                            </span>
                        </span>
                    </label>
                )}
                 </div>
              {props.displayError && props.error ?
            <span className='input error'><p id={`${props.id || props.name}_error`} className="message error">
                <span
                    className="icon xsmall"
                    style={{
                        WebkitMaskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                        maskImage: "url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)",
                        color: "currentColor"
                    }}>
                </span>
                {props.error}
            </p>
            </span>
            :
            <span className='input'>
            <p id={`${props.id || props.name}_message`} className="message">
                {props.message}
            </p>
            </span>
        }
        </fieldset>
    )
}

export default RadioGroup;